//hook
import { useState, useEffect,} from 'react';
import { useApi } from '../../../hooks/useApi';
import { UserConsumer } from '../../../hooks/context/UserContext';


//component
import CarCard from '../../../component/carCard/CarCard';
import PopularCar from '../../../component/popularCar/PopularCar';

//api
import { GetBestCarsApi } from '../../../api/Cars/GetBestCarsApi';
import { GetPopularCarsApi } from '../../../api/Cars/GetPopularCarsApi';
import { GetRecommendedCarsApi } from '../../../api/Cars/GetRecommendedCarsApi';
import { GetBarndListApi } from '../../../api/brandList/GetBarndListApi';


//type
import { carType } from '../../../api/Cars/type/CarsType';
import { brandsType } from '../../../api/brandList/type/BrandsType';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../../translate/i18n';

//popup
import CarDetails from '../../../popup/carDetails/CarDetails';

//image
import heroSign from "../../../assets/home/hero-sign.png"
import heroCar from "../../../assets/home/hero-car.png"
import availability from "../../../assets/home/availability.png"
import comfort from "../../../assets/home/comfort.png"
import savings from "../../../assets/home/savings.png"
import mercedesBenz from "../../../assets/home/mercedes-benz.png"
import carIcon from "../../../assets/home/carIcon.png"
import customerIcon from "../../../assets/home/customerIcon.png"
import yearIcon from "../../../assets/home/yearIcon.png"
import mobileCollection from "../../../assets/home/mobileCollection.png"
import apple_store from "../../../assets/footer/apple-store.png";
import google_store from "../../../assets/footer/google-store.png";
import chooseLocation from "../../../assets/home/choose-location.svg"
import pickupLocation from "../../../assets/home/pickup-location.svg"
import bookYourCar from "../../../assets/home/book-your-car.svg"
import howItWorks from "../../../assets/home/how-it-work.png"

//mui
import { Button, CardActionArea } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { DialogProps } from '@mui/material/Dialog';


//mui icon
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ReplayIcon from '@mui/icons-material/Replay';


//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay  } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//css file
import styles from "./Home.module.css"

//router
import { Link } from 'react-router-dom';

//increase count
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";


const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;


const Home = () =>{
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const {userData} = UserConsumer()
  const [bestCarsData, setBestCarsData] = useState<carType[]>([]);
  const {
    loading: bestCarLoading,
    error: bestCarError,
    HandlerApi: getBestCars
  } = useApi(GetBestCarsApi, "GET");
  const [popularCarsData, setPopularCarsData] = useState<carType[]>([]);
  const {
    loading: popularCarLoading,
    error: popularCarError,
    HandlerApi: getPopularCars
  } = useApi(GetPopularCarsApi, "GET");
  const [recommendedCarsData, setRecommendedCarsData] = useState<carType[]>([]);
  const {
    loading: recommendedCarLoading,
    error: recommendedCarError,
    HandlerApi: getRecommendedCars
  } = useApi(GetRecommendedCarsApi, "GET");
  const [brandListData, setBrandListData] = useState<brandsType[]>([]);
  const {
    loading: brandListLoading,
    error: brandListError,
    HandlerApi: getBrandListApi
  } = useApi(GetBarndListApi, "GET");

  const [selectedCar, setSelectedCar] = useState<carType | null>(null);
  const [openCarDetails, setOpenCarDetails] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
    open:false,
    scrollType: "paper",
  });

useEffect(() => {
  getBestCars()
    .then((res) => {
      setBestCarsData(res.data);
    })
    .catch(() => {});
  getPopularCars()
    .then((res) => {
      setPopularCarsData(res.data);
    })
    .catch(() => {});
  getBrandListApi()
    .then((res) => {
      setBrandListData(res.data);
    })
    .catch(() => {});
  if (token && userData?.is_verified !== 0) {
    getRecommendedCars()
      .then((res) => {
        setRecommendedCarsData(res.data);
      })
      .catch(() => {});
  }
}, []);
  const { ref, inView } = useInView({
    threshold: 0.4,
    triggerOnce: false,
  });
  return (
    <div className="mt-5">
      {/* section 1 */}
      <div>
        <div className='flex justify-between'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl max-sm:mb-2'>{t("brands")}</h1>
        </div>
        <div className='mt-5'>
          {brandListLoading
          ? 
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
          :
          <div>
            {brandListError
            ?
              <div className='cursor-pointer flex justify-center'>
                <ReplayIcon onClick={getBestCars}className='!text-[40px]'/>
              </div>
            :
              <div>
                <CardActionArea>
                  <Swiper
                  breakpoints={{
                    0: { slidesPerView: 3.4 },
                    600: { slidesPerView: 6.4 },
                    816: { slidesPerView: 9.4},
                  }}
                  key={i18n.language}
                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                  spaceBetween={20}
                  grabCursor={true}
                  autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  speed={1000}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Navigation, Pagination, Autoplay]}
                  className={`carCardSwiper ${styles.carCardSwiper}`}
                  >
                    {
                      brandListData.length !== 0
                      ? 
                      <>
                      {brandListData.map((element, index) => (
                      <SwiperSlide 
                      key={index}
                      >
                      <div className='cursor-pointer'
                      key={index}
                      >
                        <div className='w-[70px] h-[70px] flex justify-center items-center box-border p-3 bg-gray-200 rounded-full'>
                          <img 
                          className='object-contain' 
                          src={`${storageURL}/${element.brand_logo}`} 
                          alt='no-photo'
                          loading="lazy"
                          decoding="async"
                          />
                        </div>
                      </div>
                      </SwiperSlide>
                    ))}
                      </>
                      :<p className='flex justify-center items-center'>{t("no_brands")}</p>
                    }
                  </Swiper>
                </CardActionArea>  
              </div>
            }
          </div>
          }
        </div>
      </div>
      {/* section 2 */}
      <div className="
      mt-5
      py-10
      bg-customerColor 
      rounded-[40px] 
      px-10
      relative
      z-[1]
      overflow-hidden

      "
      >
        <div className='flex md:flex-row max-md:flex-col items-center justify-center h-full'>
          <div className='md:w-1/2 max-md:w-full max-md:text-center'>
            <h1 
            style={{ whiteSpace: "pre-line" }} 
            className='mb-3 text-white text-5xl max-sm:text-4xl'
            >
              {t("hero_title_home")}
            </h1>
            <p 
            style={{ whiteSpace: "pre-line" }}
            className='text-white'
            >
              {t("hero_desc_home")}
            </p>
            <Link to={'available_cars'}>
              <Button className='!bg-darkColor !mt-5 !text-white !capitalize'>
                {t("view_all_cars")}
              </Button>
            </Link>
          </div>
          <div className='md:w-1/2 max-md:w-[400px]'>
            <img 
            className={`${i18n.language === "en" ? "": "scale-x-[-1]"}`} 
            src={heroCar} 
            alt='no-photo'
            loading="lazy"
            decoding="async"
            />
          </div>
        </div>
        <img 
        className={`${i18n.language === "en" ? "": "scale-x-[-1]"} w-full h-full absolute top-0 left-0 z-[-1]`}
        src={heroSign} 
        alt='no-photo'
        loading="lazy"
        decoding="async"
        />
      </div>
      {/* section 3 */}
      <div className='mt-20'>
        <div className='mb-20 text-center'>
          <h2 className='text-darkColor font-[800] text-3xl max-sm:text-xl mb-2'>{t("how_it_works")}</h2>
          <div className='mt-5 mb-5'>
            <img 
            className='m-auto' 
            src={howItWorks} 
            alt='no-photo'
            loading="lazy"
            decoding="async"
            />
          </div>
          <p>{t("how_it_works_info")}</p>
        </div>
        <div className='grid grid-cols-3 grid-rows-1 gap-5 mt-5'>
          <div className='flex items-center flex-col gap-3 text-center'>
            <div className='border-2 border-dashed border-[#127384] p-2 rounded-full'>
              <div className='bg-[#127384] w-fit p-2 rounded-full'>
                <img 
                className='m-auto' 
                src={chooseLocation} 
                alt='no-photo'
                loading="lazy"
                decoding="async"
                />
              </div>
            </div>
            <h3 className='font-[800] md:text-[24px] text-[18px]'>{t("choose_locations")}</h3>
            <p className='flex-1 max-sm:text-xs'>{t("choose_locations_info")}</p>
          </div>
          <div className='flex items-center flex-col gap-3 text-center'>
            <div className='border-2 border-dashed border-[#FFA633] p-2 rounded-full'>
              <div className='bg-[#FFA633] w-fit p-2 rounded-full'>
                <img 
                className='m-auto' 
                src={pickupLocation} 
                alt='no-photo'
                loading="lazy"
                decoding="async"
                />
              </div>
            </div>
            <h3 className='font-[800] md:text-[24px] text-[18px]'>{t("pickup_locations")}</h3>
            <p className='flex-1 max-sm:text-xs'>{t("pickup_locations_info")}</p>
          </div>
          <div className='flex items-center flex-col gap-3 text-center'>
            <div className='border-2 border-dashed border-[#212529] p-2 rounded-full'>
              <div className='bg-[#212529] w-fit p-2 rounded-full'>
                <img 
                className='m-auto' 
                src={bookYourCar} 
                alt='no-photo'
                loading="lazy"
                decoding="async"
                />
              </div>
            </div>
            <h3 className='font-[800] md:text-[24px] text-[18px]'>{t("book_your_car")}</h3>
            <p className='flex-1 max-sm:text-xs'>{t("book_your_car_info")}</p>
          </div>
        </div>

      </div>
      {/* section 4 */}
      <div className='mt-20 max-sm:mt-10 flex max-sm:flex-col justify-between items-center'>
        <div className="flex items-center justify-center 
        lg:w-[350px] lg:h-[350px] md:w-[300px] md:h-[300px] sm:w-[250px] sm:h-[250px] max-sm:w-[200px] max-sm:h-[200px]
        rounded-full"
        style={{ background: 'conic-gradient(#34A835 0deg 180deg, #373737 180deg 360deg)'}}
        >
          <img 
          className={i18n.language === "en" ? "": "scale-x-[-1]"} 
          src={mercedesBenz} 
          alt='no-photo'
          loading="lazy"
          decoding="async"
          />
        </div>
        <div className='w-1/2 max-sm:w-full max-sm:mt-5'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl mb-2'>{t("our_services")}</h1>
          <div className='mb-5'>
            <h4 className='font-[800] mb-2'>{t("car_hire")} : </h4>
            <p>{t("car_hire_info")}</p>
          </div>
          <div className='mb-5'>
            <h4 className='font-[800] mb-2'>{t("host_hire")} : </h4>
            <p>{t("host_hire_info")}</p>
          </div>
          <div className='mb-5'>
            <h4 className='font-[800] mb-2'>{t("driver_hire")} : </h4>
            <p>{t("driver_hire_info")}</p>
          </div>
        </div>
      </div>
      {/* section 5 */}
      <div className='mt-20'>
        <div className='flex justify-between'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl max-sm:mb-2'>{t("best_cars")}</h1>
          <div className='flex gap-2'>
            <Link to={'available_cars'}>
              <p className='max-sm:text-sm'>{t("view_all")}</p>
            </Link>
            {i18n.language === "en" ? <ArrowForwardIcon/> : <ArrowBackOutlinedIcon/>}
          </div>
        </div>
        <div className='mt-5'>
          {bestCarLoading
          ? 
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
          :
          <div>
            {bestCarError
            ?
              <div className='cursor-pointer flex justify-center'>
                <ReplayIcon onClick={getBestCars}className='!text-[40px]'/>
              </div>
            :
              <div>
                <CardActionArea>
                  <Swiper
                  breakpoints={{
                    0: { slidesPerView: 1.5 },
                    600: { slidesPerView: 2.5 },
                    816: { slidesPerView: 3.5 },
                  }}
                  key={i18n.language}
                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                  spaceBetween={20}
                  grabCursor={true}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Navigation, Pagination]}
                  className={`carCardSwiper ${styles.carCardSwiper}`}
                  >
                    {
                      bestCarsData.length !== 0
                      ? 
                      <>
                      {bestCarsData.map((element, index) => (
                      <SwiperSlide 
                      key={index}
                      >
                      <div className='cursor-pointer'
                      key={index}
                      onClick={() => {setOpenCarDetails({open: true, scrollType: "paper"}); setSelectedCar(element)}}
                      >
                        <CarCard element={element}/>
                      </div>
                      </SwiperSlide>
                    ))}
                      </>
                      :<p className='flex justify-center items-center'>{t("no_cars")}</p>
                    }
                  </Swiper>
                </CardActionArea>  
              </div>
            }
          </div>
          }
        </div>
      </div>
      {/* section 6 */}
      <div className='mt-20'>
        <div className='flex justify-between'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl max-sm:mb-2'>{t("popular_cars")}</h1>
          <div className='flex gap-2'>
            <Link to={'available_cars'}>
              <p className='max-sm:text-sm'>{t("view_all")}</p>
            </Link>
            {i18n.language === "en" ? <ArrowForwardIcon/> : <ArrowBackOutlinedIcon/>}
          </div>
        </div>
        <div className='mt-5'>
          {popularCarLoading
          ? 
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
          :
          <div>
            {popularCarError
            ?
              <div className='cursor-pointer flex justify-center'>
                <ReplayIcon onClick={getPopularCars} className='!text-[40px]'/>
              </div>
            :
              <div>
                <CardActionArea>
                  <Swiper
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    300: { slidesPerView: 1.5 },
                    640: { slidesPerView: 3.5 },
                  }}
                  key={i18n.language}
                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                  spaceBetween={20}
                  grabCursor={true}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Navigation, Pagination]}
                  className={`carCardSwiper ${styles.carCardSwiper}`}
                  >
                    {
                      popularCarsData.length !== 0
                      ?
                      <>
                      {
                       popularCarsData.map((element, index) => (
                          <SwiperSlide 
                          key={index}
                          >
                            <div className='cursor-pointer'
                            onClick={() => {setOpenCarDetails({open: true, scrollType: "paper"}); setSelectedCar(element)}}
                            >
                              <PopularCar element={element}/>
                            </div>
                          </SwiperSlide>
                        ))
                      }
                      </>
                      :<p className='flex justify-center items-center'>{t("no_cars")}</p>
                    }
                  </Swiper>
                </CardActionArea>
              </div>
            }
          </div>
          }
        </div>
      </div>
      {/* section 7 */}
      <div className='mt-20'>
        <div className="
        bg-customerColor
        rounded-[40px]
        sm:p-12
        max-sm:p-6
        relative
        z-[1]
        overflow-hidden
        "
        >
          <div>
            <div className='text-center mb-10 text-white'>
              <p className='text-[50px] mb-3'>{t("facts_in_numbers")}</p>
              <p>{t("facts_in_numbers_info")}</p>
            </div>
            <div className='flex max-md:flex-col max-md:gap-5 justify-evenly max-md:items-center'>
              <div className='flex items-center gap-5 bg-white rounded-lg p-5 lg:w-[240px] md:w-[200px] max-md:w-[240px] h-[100px]'>
                <div className='rounded-lg  bg-[#FF9E0C] p-5'>
                  <img 
                  src={carIcon} 
                  alt='no-photo'
                  loading="lazy"
                  decoding="async"
                  />
                </div>
                <div ref={ref} className='flex flex-col items-start'>
                  <p className='font-[800] text-2xl'>
                    {inView ? (
                      <CountUp
                        key={inView ? "on" : "off"}
                        end={540}
                        duration={1.8}
                      />
                    ) : (
                      0
                    )}
                  </p>
                  <p>{t("cars")}</p>
                </div>
              </div>
              <div className='flex items-center gap-5 bg-white rounded-lg p-5 lg:w-[240px] md:w-[200px] max-md:w-[240px] h-[100px]'>
                <div className='rounded-lg  bg-[#FF9E0C] p-5'>
                  <img 
                  src={customerIcon} 
                  alt='no-photo'
                  loading="lazy"
                  decoding="async"
                  />
                </div>
                <div ref={ref} className='flex flex-col items-start'>
                  <p className='font-[800] text-2xl'>
                    {/* {
                      i18n.language === "en" 
                        ? "+20KM"
                        : "20+الف"
                    } */}
                    {inView ? (
                      <CountUp
                        key={inView ? "on" : "off"}
                        end={20000}
                        duration={1.8}
                      />
                    ) : (
                      0
                    )}
                  </p>
                  <p>{t("customer")}</p>
                </div>
              </div>
              <div className='flex items-center gap-5 bg-white rounded-lg p-5 lg:w-[240px] md:w-[200px] max-md:w-[240px] h-[100px]'>
                <div className='rounded-lg  bg-[#FF9E0C] p-5'>
                  <img 
                  src={yearIcon} 
                  alt='no-photo'
                  loading="lazy"
                  decoding="async"
                  />
                </div>
                <div ref={ref} className='flex flex-col items-start'>
                  <p className='font-[800] text-2xl'>
                    {inView ? (
                      <CountUp
                        key={inView ? "on" : "off"}
                        end={3}
                        duration={1.8}
                      />
                    ) : (
                      0
                    )}
                  </p>
                  <p>{t("year")}</p>
                </div>
              </div>
            </div>
          </div>
          <img 
          className={`${i18n.language === "en" ? "": "scale-x-[-1]"} w-full h-full absolute top-0 left-0 z-[-1]`}
          src={heroSign} 
          alt='no-photo'
          loading="lazy"
          decoding="async"
          />
        </div>
      </div>
      {/* section 8 */}
      {token && userData?.is_verified !== 0
      ?
      <div className='mt-20'>
        <div className='flex justify-between'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl max-sm:mb-2'>{t("recommended_cars")}</h1>
          <div className='flex gap-2'>
            <Link to={'available_cars'}>
              <p className='max-sm:text-sm'>{t("view_all")}</p>
            </Link>
            {i18n.language === "en" ? <ArrowForwardIcon/> : <ArrowBackOutlinedIcon/>}
          </div>
        </div>
        <div className='mt-5'>
          {recommendedCarLoading
          ? 
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
          :
          <div>
            {recommendedCarError
            ?
              <div className='cursor-pointer flex justify-center'>
                <ReplayIcon onClick={getBestCars}className='!text-[40px]'/>
              </div>
            :
              <div>
                <CardActionArea>
                  <Swiper
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    300: { slidesPerView: 1.5 },
                    640: { slidesPerView: 3.5 },
                  }}
                  key={i18n.language}
                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                  spaceBetween={20}
                  grabCursor={true}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Navigation, Pagination]}
                  className={`carCardSwiper ${styles.carCardSwiper}`}
                  >
                    {
                      recommendedCarsData.length !== 0
                      ? 
                      <>
                        {recommendedCarsData.map((element, index) => (
                          <SwiperSlide
                          key={index}
                          >
                          <div className='cursor-pointer'
                          key={index}
                          onClick={() => {setOpenCarDetails({open: true, scrollType: "paper"}); setSelectedCar(element)}}
                          >
                            <CarCard element={element}/>
                          </div>
                          </SwiperSlide>
                        ))}
                      </>
                      :<p className='flex justify-center items-center'>{t("no_cars")}</p>
                    }
                  </Swiper>
                </CardActionArea>  
              </div>
            }
          </div>
          }
        </div>
      </div>
      : null
      }
      {/* section 9 */}
      <div className='mt-20'>
        <div className='mb-20 text-center'>
          <h2 className='text-darkColor font-[800] text-3xl max-sm:text-xl mb-2'>{t("why_choose_us")}</h2>
          <div className='mt-5 mb-5'>
            <img 
            className='m-auto' 
            src={howItWorks} 
            alt='no-photo'
            loading="lazy"
            decoding="async"
            />
          </div>
          <p>{t("why_choose_us_info")}</p>
        </div>
        <div className='grid grid-cols-3 grid-rows-1 gap-3 mt-5'>
          <div className="flex flex-col gap-3 text-center sm:p-6 p-1 rounded-xl bg-white shadow-2xl hover:shadow-xl transition-shadow duration-300">
            <div>
              <img 
              className='m-auto' 
              src={availability} 
              alt='no-photo'
              loading="lazy"
              decoding="async"
              />
            </div>
            <h3 className='font-[800] max-sm:text-[13px]'>{t("availability")}</h3>
            <p className='flex-1 max-sm:text-[10px]'>{t("availability_info")}</p>
          </div>
          <div className="flex flex-col gap-3 text-center sm:p-6 p-1 rounded-xl bg-white shadow-2xl hover:shadow-xl transition-shadow duration-300">           
            <div>
              <img 
              className='m-auto' 
              src={comfort} 
              loading="lazy"
              decoding="async"
              />
            </div>
            <h3 className='font-[800] max-sm:text-[13px]'>{t("comfort")}</h3>
            <p className='flex-1 max-sm:text-[10px]'>{t("comfort_info")}</p>
          </div>
          <div className="flex flex-col gap-3 text-center sm:p-6 p-1 rounded-xl bg-white shadow-2xl hover:shadow-xl transition-shadow duration-300">           
            <div>
              <img 
              className='m-auto' 
              src={savings} 
              alt='no-photo'
              loading="lazy"
              decoding="async"
              />
            </div>
            <h3 className='font-[800] max-sm:text-[13px]'>{t("savings")}</h3>
            <p className='flex-1 max-sm:text-[10px]'>{t("savings_info")}</p>
          </div>
        </div>
      </div>
      {/* section 10 */}
      <div className='flex max-sm:flex-col gap-5 justify-evenly items-center mt-20'>
        <div className='max-sm:w-[300px]'>
          <img 
          src={mobileCollection} 
          alt='no-photo' 
          className='w-full h-full object-cover'
          loading="lazy"
          decoding="async"
          />
        </div>
        <div className='w-1/2 max-sm:w-full'>
          <h2 className="font-[700] mb-3 text-[40px] max-md:text-[25px]">{t("download_app")}</h2>
          <p className='mb-3'>{t("download_app_info")}</p>
          {/* Download App */}
          <div className="flex gap-3 items-center lg:items-start mt-10">
              <div className={`flex items-center gap-2 !bg-customerColor text-white rounded-lg p-2 hover:opacity-90 transition`}>
                  <img 
                  src={apple_store} 
                  alt="Apple store" 
                  className="w-8 h-8" 
                  loading="lazy"
                  decoding="async"
                  />
                  <div>
                  <p className="text-xs">{t("download_from")}</p>
                  <p className="font-[600] text-sm">{t("app_store")}</p>
                  </div>
              </div>
              <div className={`flex items-center gap-2 !bg-customerColor text-white rounded-lg p-2 hover:opacity-90 transition`}>
                  <img 
                  src={google_store} 
                  alt="Google play" 
                  className="w-8 h-8" 
                  loading="lazy"
                  decoding="async"
                  />
                  <div>
                  <p className="text-xs">{t("download_from")}</p>
                  <p className="font-[600] text-sm">{t("google_play")}</p>
                  </div>
              </div>
          </div>
        </div>
      </div>
      {selectedCar && (
        <CarDetails
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          openCarDetails={openCarDetails}
          setOpenCarDetails={setOpenCarDetails}
        />
      )} 
    </div>
  )
}

export default Home
